var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumSticky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2787 2.42931C2.28789 2.33852 2.27557 2.24684 2.24273 2.16169C2.20988 2.07655 2.15744 2.00034 2.08966 1.93924L0.68893 0.25191V0H5.03779L8.399 7.3719L11.3544 0H15.5V0.25202L14.3025 1.40015C14.2519 1.43876 14.2127 1.49047 14.1893 1.54969C14.1658 1.60891 14.159 1.6734 14.1695 1.73622V10.1722C14.159 10.235 14.1658 10.2995 14.1893 10.3587C14.2127 10.4179 14.2519 10.4696 14.3025 10.5083L15.4719 11.6564V11.9084H9.5897V11.6564L10.8011 10.4802C10.9202 10.3611 10.9202 10.3262 10.9202 10.1442V3.32542L7.5518 11.8804H7.0966L3.17504 3.32542V9.0591C3.15891 9.1781 3.17008 9.2991 3.20769 9.4132C3.24531 9.5272 3.30838 9.6311 3.39214 9.7171L4.96771 11.6283V11.8804H0.5V11.6284L2.07557 9.7171C2.15865 9.6311 2.22033 9.5267 2.25561 9.4123C2.2909 9.298 2.29881 9.177 2.2787 9.0591V2.42931Z",
    fill: "#14161E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumSticky);
export default __webpack_public_path__ + "static/media/mediumSticky.10ed6cd919ad2ad9aa1db8a6f9a00e70.svg";
export { ForwardRef as ReactComponent };